import React, { useEffect, useState } from "react";
import ReactEcharts from "echarts-for-react";
import { Spinner, Table, Row, Col } from "reactstrap";

function VulnerabilityChartTables() {
  const [analyticsData, setAnalyticsData] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        const headers = {
          "Content-Type": "application/json",
          ...(authUser?.token && { Authorization: `Bearer ${authUser.token}` }),
        };

        const res = await fetch("http://localhost:5050/api/vulnerabilities/stats", { headers });
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        if (json.success) {
          const breakdown = Object.entries(json.severity_breakdown).map(([severity, count]) => ({
            severity,
            count
          }));
          setAnalyticsData(breakdown);
          setStats(json.stats);
        }
      } catch (err) {
        console.error("Error fetching vulnerability stats:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const isDarkMode = document.documentElement.getAttribute("data-layout-mode") === "dark";
  const textColor = isDarkMode ? "#a6b0cf" : "#858d98";

  if (loading) {
    return (
      <div className="text-center p-3">
        <Spinner color="danger" />
        <p className="text-muted">Loading chart...</p>
      </div>
    );
  }

  if (!analyticsData || analyticsData.length === 0) {
    return (
      <div className="text-center py-5">
        <i className="ri-pie-chart-line display-4 mb-3 d-block" style={{ color: "#ff8c61" }}></i>
        <p className="text-muted">No severity data available</p>
      </div>
    );
  }

  const severityData = analyticsData.map(item => ({
    value: item.count,
    name: item.severity
  }));

  const colorMap = {
    Critical: "#dc2626",
    High: "#ea580c",
    Medium: "#eab308",
    Low: "#16a34a"
  };

  const totalThreats = severityData.reduce((sum, item) => sum + item.value, 0);

  const option = {
    tooltip: {
      trigger: "item",
      textStyle: { color: textColor, fontSize: 12 },
      formatter: params => {
        const percentage = ((params.value / totalThreats) * 100).toFixed(1);
        return `<strong>${params.name}</strong><br/>${params.value} threats (${percentage}%)`;
      }
    },
    legend: {
      orient: "vertical",
      left: "left",
      top: "middle",
      textStyle: { color: textColor, fontSize: 12 },
      itemGap: 12
    },
    color: severityData.map(item => colorMap[item.name] || "#ff6b35"),
    series: [
      {
        name: "Severity Levels",
        type: "pie",
        radius: ["45%", "70%"],
        center: ["50%", "50%"],
        data: severityData,
        label: {
          color: textColor,
          fontSize: 11,
          fontWeight: "bold",
          formatter: params => {
            const percentage = ((params.value / totalThreats) * 100).toFixed(1);
            return `${params.value}\n${percentage}%`;
          }
        }
      }
    ]
  };

  return (
    <div className="bg-white text-dark p-3 rounded shadow-sm">
      <h5 className="mb-3 text-dark text-start"style={{ backgroundColor: "#FFB380", border: "none", padding: "1rem 1.5rem", }} >Vulnerability Overview</h5>
      <Row>
      
        <Col md={6}>
          <ReactEcharts style={{ height: "310px" }} option={option} />
        </Col>

     
        <Col md={6}>
          <Table bordered hover responsive className="align-middle mb-0 rounded mt-3">
            <thead >
              <tr>
                <th className="text-primary">Metric</th>
                <th className="text-primary">Count</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Total Vulnerabilities</td><td>{stats?.total_vulnerabilities}</td></tr>
              <tr><td>Critical</td><td>{stats?.critical}</td></tr>
              <tr><td>High</td><td>{stats?.high}</td></tr>
              <tr><td>Medium</td><td>{stats?.medium}</td></tr>
              <tr><td>Low</td><td>{stats?.low}</td></tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  );
}

export default VulnerabilityChartTables;
